<div class="chat-shell">
    <section class="fo-card chat-card">
        <header class="chat-header" *ngIf="ticket">
            <div class="chat-header-inner">
                <span class="chat-header-title" *ngIf="showReplyMessage"
                    >CHAT IN CORSO</span
                >
                <span
                    class="chat-header-title chat_close"
                    *ngIf="!showReplyMessage"
                    >CHAT TERMINATA</span
                >

                <button
                    type="button"
                    class="chat-header-close"
                    (click)="exit()"
                    *ngIf="showReplyMessage"
                >
                    <mat-icon>close</mat-icon>
                    <span class="chat-header-close-label">Chiudi</span>
                </button>
                <button
                    type="button"
                    class="chat-header-close chat_close"
                    (click)="goHome()"
                    *ngIf="!showReplyMessage"
                >
                    <mat-icon>home</mat-icon>
                    <span class="chat-header-close-label">Home</span>
                </button>
            </div>
        </header>

        <div class="timer__container" *ngIf="ticket">
            <div class="timer__container-inner">
                <span class="chat-header-operator">Operatore: {{ opName }}</span>
                <div
                    class="timer--count text-right"
                    *ngIf="showReplyMessage"
                    [class.redTimer]="exceededTime"
                >
                    {{ timer }}
                </div>
            </div>
        </div>

        <div class="message__container">
            <ng-scrollbar trackX="false" class="scrollbar">
                <div class="chat-thread">
                    <div
                        class="chat-messages"
                        *ngFor="let message of ticketHistorys"
                    >
                        <div
                            class="message-row"
                            [ngClass]="{ user: message.type.type !== 'OPERATOR' }"
                        >
                            <div class="bubble">
                                <div
                                    class="message"
                                    [innerHtml]="message.action"
                                ></div>
                            </div>
                            <div class="time">
                                {{
                                    message.date_time
                                        | date : "dd/MM/yyyy, HH:mm" : "UTC"
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </ng-scrollbar>
        </div>

        <div #onWritingMsg class="on-writing">
            L'operatore sta scrivendo........
        </div>

        <div class="chat-footer" [hidden]="!ticket">
            <div class="chat-footer-inner">
                <form
                    #replyForm="ngForm"
                    (ngSubmit)="reply($event)"
                    (keyup.enter)="reply($event)"
                    (keydown)="typing($event)"
                    class="reply-form"
                >
                    <mat-form-field
                        class="fo-field reply-field"
                        floatPlaceholder="never"
                    >
                        <textarea
                            matInput
                            #replyInput
                            ngModel
                            name="message"
                            [disabled]="!showReplyMessage"
                        ></textarea>
                        <mat-label [hidden]="!showReplyMessage"
                            >Scrivi il messaggio e premi Enter</mat-label
                        >
                        <mat-label [hidden]="showReplyMessage"
                            >Chat terminata. Tornare alla Home Page, Grazie.
                        </mat-label>
                    </mat-form-field>
                    <button
                        mat-mini-fab
                        class="send__button"
                        type="submit"
                        aria-label="Send message"
                        [hidden]="!showReplyMessage"
                    >
                        <mat-icon>send</mat-icon>
                    </button>
                </form>
            </div>
        </div>
    </section>
</div>
